import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { createhomework, stuacademicyearlist, stuclasslist, studivisionlist, stusubjectlist } from "../service/dashboard";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";

const AddHomework = () => {
    const navigate = useNavigate();
    const [alist, setAList] = useState([]);
    const [clist, setCList] = useState([]);
    const [slist, setSList] = useState([]);
    const [sublist, setSubList] = useState([]);

    const [form, setForm] = useState({
        acayear: "",
        class: "",
        section: [],
        dueDate: moment(new Date()).format("YYYY-MM-DD"),
    });

    // multi-subject state
    const [subjects, setSubjects] = useState([]);
    const [subjectDescs, setSubjectDescs] = useState({});
    const [subjectFiles, setSubjectFiles] = useState({});
    const [subjectFileUrls, setSubjectFileUrls] = useState({});
    const [subjectFileErrors, setSubjectFileErrors] = useState({});

    const [subhome, setSubHome] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSecChange = (value, actionMeta) => {
        if (actionMeta.name === 'section') {
            setForm({ ...form, section: value ? value.map(v => v.value) : [] });
        }
    };

    function handleSubjectChange(selected) {
        setSubjects(selected || []);
        setSubjectDescs((prev) => {
            const next = {};
            (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
            return next;
        });
        setSubjectFiles((prev) => {
            const next = {};
            (selected || []).forEach((s) => { next[s.value] = prev[s.value] || null; });
            return next;
        });
        setSubjectFileUrls((prev) => {
            const next = {};
            (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
            return next;
        });
        setSubjectFileErrors((prev) => {
            const next = {};
            (selected || []).forEach((s) => { next[s.value] = prev[s.value] || ""; });
            return next;
        });
    }

    function handleSubjectDesc(subId, val) {
        setSubjectDescs((prev) => ({ ...prev, [subId]: val }));
    }

    function handleSubjectFile(subId, event) {
        setSubjectFileErrors((prev) => ({ ...prev, [subId]: "" }));
        setSubjectFiles((prev) => ({ ...prev, [subId]: null }));
        setSubjectFileUrls((prev) => ({ ...prev, [subId]: "" }));
        if (event.target.files.length !== 0) {
            const file = event.target.files[0];
            if (!file.name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
                setSubjectFileErrors((prev) => ({ ...prev, [subId]: "Attachment should be jpg, jpeg, png or pdf format" }));
                return;
            }
            if (file.size / 1024 / 1024 > 5) {
                setSubjectFileErrors((prev) => ({ ...prev, [subId]: "Attachment size should be less than 5MB" }));
                return;
            }
            setSubjectFileUrls((prev) => ({ ...prev, [subId]: URL.createObjectURL(file) }));
            setSubjectFiles((prev) => ({ ...prev, [subId]: file }));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubHome(true);

        if (!form.acayear) { toast.error("Please Select Academic Year"); return; }
        if (!form.class) { toast.error("Please Select Class"); return; }
        if (form.section.length === 0) { toast.error("Please Select Section"); return; }
        if (subjects.length === 0) { toast.error("Please Select at least one Subject"); return; }
        if (!form.dueDate) { toast.error("Please Select Due Date"); return; }

        const hasEmptyDesc = subjects.some((s) => !subjectDescs[s.value]?.trim());
        if (hasEmptyDesc) { toast.error("Please enter description for all selected subjects"); return; }

        setLoading(true);

        const baseData = () => {
            const temp = new FormData();
            temp.append("academy", localStorage.getItem("academy"));
            temp.append("academic_year", form.acayear);
            temp.append("class_id", form.class);
            temp.append("due_date", form.dueDate);
            form.section.forEach(sec => temp.append("section[]", sec));
            return temp;
        };

        try {
            for (const sub of subjects) {
                const temp = baseData();
                temp.append("subject", sub.value);
                temp.append("description", subjectDescs[sub.value]);
                if (subjectFiles[sub.value]) temp.append("work_file", subjectFiles[sub.value]);
                const response = await createhomework(temp);
                if (!response || response.status !== true) {
                    toast.error(response?.message || "Failed to save homework");
                    setLoading(false);
                    return;
                }
            }
            setLoading(false);
            toast.success("Homework Created Successfully");
            setSubHome(false);
            navigate("/homework");
        } catch {
            setLoading(false);
            toast.error("Something went wrong");
        }
    };

    useEffect(() => {
        stuclasslist().then((res) => {
            if (res.status === true) {
                setCList(res.data.map((item) => ({ value: item.id, label: item.class_name })));
            }
        });

        studivisionlist().then((res) => {
            if (res.status === true) {
                setSList(res.data.map((item) => ({ value: item.id, label: item.name })));
            }
        });

        stusubjectlist().then((res) => {
            if (res.status === true) {
                setSubList(res.data);
            }
        });

        const temp = new FormData();
        temp.append("academy_id", localStorage.getItem("academy"));
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                const sorted = [...res.data].sort((a, b) => Number(b.id) - Number(a.id));
                setAList(sorted.map((item) => ({ value: item.id, label: item.aca_year })));
                if (sorted.length > 0) {
                    setForm((prev) => ({ ...prev, acayear: sorted[0].id }));
                }
            }
        });
    }, []);

    const subjectOptions = sublist.map((item) => ({ value: item.id, label: item.subject_name }));

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">
                        <div className="col-7 pr-0 text-left align-self-end">
                            <h4 className="morehead-text">Home Work</h4>
                        </div>
                        <div className="col-5 pl-0 text-right align-self-end">
                            <Link to={"/homework"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </div>
                    </Row>
                </div>

                {loading && (
                    <div className="text-center p-4">
                        <div className="spinner-border text-success" role="status"></div>
                        <p className="mt-2">Saving... Please do not go back.</p>
                    </div>
                )}

                {!loading && (
                    <div className="card shadow-sm">
                        <div className="card-header add-homework-header">
                            Add Homework
                        </div>
                        <div className="card-body">

                            {/* Academic Year */}
                            <div className="mb-3">
                                <label className="form-label attachment">Academic Year <span>*</span></label>
                                <select
                                    className="form-select"
                                    name="acayear"
                                    value={form.acayear}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Select Academic Year</option>
                                    {alist.map((item, i) => (
                                        <option value={item.value} key={i}>{item.label}</option>
                                    ))}
                                </select>
                                {subhome && !form.acayear && (
                                    <span className="text-danger">Please Select Academic Year</span>
                                )}
                            </div>

                            {/* Class */}
                            <div className="mb-3">
                                <label className="form-label attachment">Class <span>*</span></label>
                                <select
                                    className="form-select"
                                    name="class"
                                    value={form.class}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Class</option>
                                    {clist.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {subhome && !form.class && (
                                    <span className="text-danger">Please Select Class</span>
                                )}
                            </div>

                            {/* Section */}
                            <div className="mb-3">
                                <label className="form-label attachment">Section <span>*</span></label>
                                <Select
                                    className="default-select"
                                    name="section"
                                    placeholder="Select Section"
                                    value={slist.filter(opt => form.section.includes(opt.value))}
                                    options={slist}
                                    onChange={handleSecChange}
                                    isSearchable
                                    isClearable
                                    isMulti
                                />
                                {subhome && form.section.length === 0 && (
                                    <span className="text-danger">Please Select Section</span>
                                )}
                            </div>

                            {/* Subject multi-select */}
                            <div className="mb-3">
                                <label className="form-label attachment">Subject <span>*</span></label>
                                <Select
                                    isMulti
                                    className="default-select"
                                    placeholder="Select Subject(s)"
                                    value={subjects}
                                    options={subjectOptions}
                                    onChange={handleSubjectChange}
                                    isSearchable
                                />
                                {subhome && subjects.length === 0 && (
                                    <span className="text-danger">Please Select at least one Subject</span>
                                )}
                            </div>

                            {/* Due Date */}
                            <div className="mb-3">
                                <label className="form-label attachment">Due Date <span>*</span></label>
                                <input
                                    type="date"
                                    name="dueDate"
                                    className="form-control"
                                    value={form.dueDate}
                                    onChange={handleChange}
                                />
                                {subhome && !form.dueDate && (
                                    <span className="text-danger">Please Select Due Date</span>
                                )}
                            </div>

                            {/* Per-subject description + attachment */}
                            {subjects.length > 0 && (
                                <div className="mb-3">
                                    <label className="form-label attachment fw-bold">
                                        Homework Description <span>*</span>
                                    </label>
                                    {subjects.map((sub) => (
                                        <div className="border rounded p-3 mb-3" key={sub.value}>
                                            <h6 className="fw-semibold mb-2">{sub.label}</h6>
                                            <textarea
                                                className="form-control mb-2"
                                                rows="3"
                                                placeholder={`Description for ${sub.label}`}
                                                value={subjectDescs[sub.value] || ""}
                                                onChange={(e) => handleSubjectDesc(sub.value, e.target.value)}
                                            />
                                            {subhome && !subjectDescs[sub.value]?.trim() && (
                                                <span className="text-danger d-block mb-1">
                                                    Please enter description for {sub.label}
                                                </span>
                                            )}
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept=".pdf,.jpg,.png,.jpeg"
                                                onChange={(e) => handleSubjectFile(sub.value, e)}
                                            />
                                            <small className="text-muted">
                                                File Format: .pdf, .jpg, .png, .jpeg (max 5MB)
                                            </small>
                                            {subjectFileErrors[sub.value] && (
                                                <span className="text-danger d-block">{subjectFileErrors[sub.value]}</span>
                                            )}
                                            {subjectFileUrls[sub.value] && (
                                                <div className="mt-2">
                                                    {subjectFiles[sub.value]?.name?.match(/\.pdf$/i) ? (
                                                        <a href={subjectFileUrls[sub.value]} target="_blank" rel="noreferrer">
                                                            <img
                                                                src={require("../assets/images/pdf.png")}
                                                                alt="PDF"
                                                                width="60px"
                                                                height="60px"
                                                            />
                                                        </a>
                                                    ) : (
                                                        <a href={subjectFileUrls[sub.value]} target="_blank" rel="noreferrer">
                                                            <img
                                                                src={subjectFileUrls[sub.value]}
                                                                alt="Attachment"
                                                                width="60px"
                                                                height="60px"
                                                            />
                                                        </a>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Submit */}
                            <div className="d-grid">
                                <button type="submit" className="btn add-homework-submit" onClick={handleSubmit}>
                                    Submit Homework
                                </button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default AddHomework;
